const styles = (theme) => ({
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: -25,
    marginTop: -25,
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
});

export default styles;
